import styled from 'styled-components';
import { colors, radius, shadowS } from '@ardoq/design-tokens';
import { Icon, IconName, IconSize } from '@ardoq/icons';
import { FlexBox } from '@ardoq/layout';
import { Text } from '@ardoq/typography';
import { Link } from '@ardoq/link';
import { t, type I18nLocale } from '@ardoq/i18n';

type FloatingClickOtherComponentsHintProps = {
  onClickNeverShowAgainHints: () => void;
  i18nLocale: I18nLocale;
};

export const FloatingClickOtherComponentsHint = ({
  onClickNeverShowAgainHints,
  i18nLocale,
}: FloatingClickOtherComponentsHintProps) => {
  return (
    <FloatingWrapper onClick={event => event.stopPropagation()}>
      <FlexBox gap="medium" padding="small" align="center">
        <FlexBox gap="small" align="center">
          <Icon
            iconName={IconName.INFO}
            iconSize={IconSize.SMALL}
            color={colors.icon}
          />
          <Text variant="text2">
            {t(
              i18nLocale,
              'viewpointBuilder:traversals.clickOtherComponentsHint',
              'Click other component types to explore further'
            )}
          </Text>
        </FlexBox>
        <Link
          typography="text2Bold"
          hideIcon
          onClick={onClickNeverShowAgainHints}
        >
          {t(
            i18nLocale,
            'viewpointBuilder:traversals.dontShowAgain',
            "Don't show again"
          )}
        </Link>
      </FlexBox>
    </FloatingWrapper>
  );
};

const FloatingWrapper = styled.div`
  position: absolute;
  width: max-content;
  left: 0;
  right: 0;
  margin-inline: auto;
  transform: translateY(60vh);

  z-index: 5;

  border-radius: ${radius.medium};
  background-color: ${colors.surfaceDefault};
  border: 1px solid ${colors.borderSubtle};
  box-shadow: ${shadowS};
`;
